export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7904.69bfb16f.jpg";